import React, { useEffect } from "react";
import { Outlet } from "react-router";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Layout from "./components/layout/Layout";
import { hydrateSession, logout } from "./features/authSlice";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const handleAuthError = () => {
      dispatch(logout());
      navigate("/connect", { replace: true });
    };

    window.addEventListener("auth:unauthorized", handleAuthError);
    return () => window.removeEventListener("auth:unauthorized", handleAuthError);
  }, [dispatch, navigate]);

  useEffect(() => {
    dispatch(hydrateSession());
  }, [dispatch]);

  useEffect(() => {
    if (
      !token &&
      !location.pathname.includes("/connect") &&
      !location.pathname.includes("/verify-email") &&
      !location.pathname.includes("/forgot-password") &&
      !location.pathname.includes("/reset-password")
    ) {
      navigate("/connect");
    } else if (
      token &&
      (location.pathname === "/" || location.pathname === "/connect")
    ) {
      navigate("/home");
    }
  }, [token, location.pathname, navigate]);

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default App;
